var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QuestionBase',{attrs:{"question":_vm.question,"errors":[..._vm.postErrors, ..._vm.jsErrors, ..._vm.serverErrors],"valid":!!_vm.data}},[_c('InputCheckBoxBasic',{attrs:{"args":_vm.args,"errors":_vm.postErrors},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }